import React, { useEffect, useState } from 'react'
import { InboxFill } from 'react-bootstrap-icons'
import MessagingService from '../../../../../../libs/api/services/MessagingService'

export default function UserEmailDiscoverComponent({ service }) {

    const [status, setStatus] = useState({ status: '', sucess: '', nextCheck: -1, total: '', details: '', action: {} })

    useEffect(() => { _check() }, [])

    const _check = async () => {
        var step = 0
        while (step !== -1) {
            const r = await MessagingService
                .DiscoverServiceProvider(service.id, step)
            setStatus(r)
            step = r.nextCheck
        }
    }

    return (
        <div className='bg-secondary-container p-3 rounded shadow'>
            <h3><InboxFill />Testing your mailbox configuration</h3>
            <div>
                <div>{status.status}</div>
                <div>{
                    status.action
                        ?
                        <button onClick={() => window.location = status.action.url}>{status.action.action}</button>
                        :
                        <></>
                }
                </div>
            </div>
        </div>
    )
}
